import store from './store';
import { i18n, router, configure } from './config';
import ValidationField from './components/ValidationField';
import * as validators from './validation';
import './styles/style.scss';
import {
  price, pricePerPeriod, priceStartsFrom, subscriptionTitle, date,
} from '@/filters';
import { markWord } from '@/directives';
import configureGoogleAnalytics from '@/config/handle-google-analytics';
import { createBootstrap, vBToggle } from 'bootstrap-vue-next';

import app from './app-instance';

app.use(store);
app.use(router);
app.use(i18n);
app.use(createBootstrap());
app.directive('b-toggle', vBToggle);
app.directive('mark-word', markWord);
void configure(app, store).then(() => {
  configureGoogleAnalytics(app);

  const forEach = (object, fn) => Object.keys(object).forEach((key) => fn(object[key], key));
  app.config.globalProperties.$price = price;
  app.config.globalProperties.$subscriptionTitle = subscriptionTitle;
  app.config.globalProperties.$date = date;
  app.config.globalProperties.$pricePerPeriod = pricePerPeriod;
  app.config.globalProperties.$priceStartsFrom = priceStartsFrom;
  app.config.globalProperties.$generateUrl = (params) => {
    const { href } = router.resolve(params, router.currentRoute.value);
    const { host, protocol } = window.location;

    return `${protocol}//${host}${href}`;
  };

  forEach(validators, (validator, id) => ValidationField.registerValidator(id, {}, validator));
  app.mount('#app');
});
